import { PortalSandboxPage } from "../../../components/gov/PortalSandboxPage";
import { GOSI_CONFIG } from "../../../components/gov/portalConfigs";

export function GosiPortalPage() {
  return <PortalSandboxPage config={GOSI_CONFIG} />;
}

export default GosiPortalPage;
